<template>
  <page>
    <div>
      <v-card>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12>
                <form ref="XMLForm">
                  <input type="file" style="display: none" ref="XMLfile" accept=".xml" @change="doValidateFile" />
                </form>
                <v-text-field
                  readonly
                  v-model="form.requestedFile"
                  :label="labels.requestedFile"
                  :error-messages="errors.collect('requestedFile')"
                  data-vv-name="requestedFile"
                  :data-vv-as="labels.requestedFile"
                  append-icon="mdi-magnify"
                  @click:append="pickFile"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-btn color="primary" dark class=" mr-2" @click="doSend">
              Upload
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
          </v-container>
        </v-card-text>
      </v-card>
    </div>

    <v-dialog v-model="processing" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      processing: false,
      showErrorDialog: false,
      labels: {
        requestedFile: 'MAS Sanction List'
      },
      form: {
        requestedFile: ''
      }
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    doValidateFile(e) {
      this.form.requestedFile = ''
      this.resetMessages()
      if (e.target.files[0]) {
        const file = e.target.files[0]
        if (file.name.indexOf('.xml') !== -1) {
          this.form.requestedFile = file.name
          const fileReader = new FileReader()
          fileReader.readAsText(file)
        } else {
          this.$toast.error('Please Select XML File (.xml) Only!')
        }
      }
      this.doUpload(e)
    },
    async doUpload(event) {
      await this.getFile(event)
    },
    async getFile(event) {
      this.file = event.target.files[0]
    },
    pickFile() {
      this.$refs.XMLForm.reset()
      this.$refs.XMLfile.click()
    },
    async doSend() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.uploadSanctionList
      if (apiUrl) {
        try {
          this.processing = true
          let formData = new FormData()
          formData.append('file', this.file)
          const result = await this.$http.post(apiUrl, formData)
          if (result.data) {
            this.$toast.success(result.data.messages[0].message)
            this.form.requestedFile = ''
          }
          this.processing = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.processing = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [uploadSanctionList]')
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit')
    }
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
